import { getField, updateField } from "vuex-map-fields";

export const stripeCheckout = {
  namespaced: true,
  state: {
    loading: false,
    isShippingOptionLoading: false,
    isShippingInformationSubmitting: false,
    isPaymentProcessing: false,
    validateShippingAddressLoading: false,
    clientSecret: null,
  },
  getters: {
    getField,
  },
  mutations: {
    updateField,
    setLoading(state, isLoading) {
      state.loading = isLoading;
    },
    setClientSecret(state, payload) {
      state.clientSecret = payload;
    },
    setShippingOptionLoading(state, isLoading) {
      state.isShippingOptionLoading = isLoading;
    },
    setShippingInformationSubmittingLoading(state, isLoading) {
      state.isShippingInformationSubmitting = isLoading;
    },
    setPaymentProcessing(state, isLoading) {
      state.isPaymentProcessing = isLoading;
    },
    setValidateShippingAddressLoading(state, isLoading) {
      state.validateShippingAddressLoading = isLoading;
    },
  },
  actions: {
    setLoading({ commit }, isLoading) {
      commit("setLoading", isLoading);
    },
    setShippingOptionLoading({ commit }, isLoading) {
      commit("setShippingOptionLoading", isLoading);
    },
    setShippingInformationSubmittingLoading({ commit }, isLoading) {
      commit("setShippingInformationSubmittingLoading", isLoading);
    },
    setPaymentProcessing({ commit }, isLoading) {
      commit("setPaymentProcessing", isLoading);
    },
    setValidateShippingAddressLoading({ commit }, isLoading) {
      commit("setValidateShippingAddressLoading", isLoading);
    },
  },
};
